// extracted by mini-css-extract-plugin
export default {"page":"k2L3nfobU+Qf5zi6OBvA6g==","header":"IBaPU-KT2xqcgm9AT7uJCA=="};